import { RemoveConfirmationAlert } from '@components/dialogs/removeConfirmationAlert';
import { useTranslation } from 'react-i18next';
import { RemoveScheduleDialogProps } from './types';

export const RemoveScheduleDialog = ({
  open,
  setOpen,
  onConfirm,
  disabled,
}: RemoveScheduleDialogProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'schedules' });

  return (
    <RemoveConfirmationAlert
      open={open}
      handleOpen={setOpen}
      title={t('removeTitle')}
      description={t('removeInfo')}
      onConfirm={() => {
        onConfirm();
        setOpen(false);
      }}
      locked={disabled}
    />
  );
};
